import { CustomerPrivacyCategory, MaskData } from './mask-data';

const StringReplacementMap: { [original: string]: string } = {};
const CategoryCounters: { [category in CustomerPrivacyCategory]: number } = {
    address: 0,
    person: 0,
    org: 0,
    location: 0,
    station: 0,
    email: 0,
    endpoint: 0,
    ocpiProfile: 0,
    serial: 0,
    randomNumber: 0,
};

export function transform(original: string[], category: CustomerPrivacyCategory): string[];
export function transform(original: string, category: CustomerPrivacyCategory): string;
export function transform(original: string | string[], category: CustomerPrivacyCategory): string | string[] {
    if (Array.isArray(original)) {
        return original.map((o) => _transform(o, category));
    } else {
        return _transform(original, category);
    }
}

function _transform(original: string, category: CustomerPrivacyCategory): string {
    if (!original) {
        return original;
    }

    const replacementKey = `${category}::${original}`;
    let replacement = StringReplacementMap[replacementKey];
    if (!replacement) {
        if (category === 'station') {
            const counter = CategoryCounters[category]++;
            replacement = StringReplacementMap[replacementKey] = `K0082${101 + counter}`;
        } else if (category === 'email') {
            const counter = Math.max(CategoryCounters['person'] - 1, 0) % MaskData['person'].length;
            replacement = StringReplacementMap[replacementKey] = emailify(MaskData['person'][counter]);
        } else {
            const categoryValuesCount = MaskData[category].length;
            const counter = CategoryCounters[category]++ % categoryValuesCount;
            replacement = StringReplacementMap[replacementKey] = MaskData[category][counter];
        }
    }
    return replacement;
}

function emailify(name: string): string {
    return name.toLowerCase().replace(/ /g, '.') + '@acme.com';
}
